<template>
  <div class="terms_and_policy mb-50">
    <!-- hero area start -->
    <div class="fancy-hero-five">
      <div class="bg-wrapper">
        <div class="container">
          <div class="text-center row">
            <div class="col-xl-9 m-auto">
              <h1 class="heading flex align-items-center">
                <img alt=""
                     src="../../assets/images/logo/cross.svg"
                     width="50"
                     height="50"
                     class="heading-icon"/>
                {{ termsData?.title || 'Terms and Conditions' }}
              </h1>
            </div>
          </div>
        </div>
      </div> <!-- /.bg-wrapper -->
    </div>
    <!-- hero area end -->
    <div class="container">
      <div class="row">
        <div class="col-lg-8 tc-content">
          <PortableText
              v-if="termsData?.blockText"
              :value="termsData.blockText"
              :components="components"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../../../sanity";
import { PortableText } from '@portabletext/vue';

export default {
  name: "TermsConditionArea",
  components: {
    PortableText
  },
  data() {
    return {
      termsData: null,
    };
  },
  async created() {
    this.termsData = await sanity.fetch(`*[_type == "generic" && slug.current == "terms-and-conditions"][0]{
      _id,
      title,
      blockText
    }`);
  }
}
</script>

<style lang="scss" scoped>
.strip {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 0 5rem 0;
  width: 100%;
  background-color: var(--lightgrey);
  font-weight: bold;
  padding: 6rem 0;
}
.fancy-hero-five {
  background-color: var(--darkblue);
  margin: 8rem 0 3rem 0;
  padding: 6rem 0;
  @media (max-width: 767px) {
    margin: 5rem 0 0 0;
    padding: 4rem 0;
  }
  .heading {
    color: white;
    display: flex;
    font-size: 4rem;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    @media (max-width: 767px) {
      font-size: 2.5rem;
    }
    .heading-icon {
      display: block;
      margin-right: 1rem;
    }
  }
}
:deep(.tc-content h2) {
  color: var(--darkblue);
  font-size: 2rem;
  font-weight: bold;
  margin:0 0 1.5rem 0;
}
:deep(.tc-content p) {
  margin: 0 0 1rem 0;
}
:deep(.tc-content a) {
  color: var(--pink);
  font-weight: bold;
}
</style>
